(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.section-header') || document.querySelector('.section-header');
      if (!this.header) return;

      this.stickyType = this.getAttribute('data-sticky-type') || 'none';
      this.headerIsAlwaysSticky = this.stickyType === 'always' || this.stickyType === 'reduce-logo-size';
      this.headerIsOnScrollUp = this.stickyType === 'on-scroll-up';
      this.headerBounds = {};
      this.preventHide = false;
      this.preventReveal = false;
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.header.classList.add(`te-header-mode-${this.stickyType}`);
      this.setHeaderHeight();

      if (this.stickyType !== 'none') {
        this.enableFixedFallback();
      }

      this.mediaQuery = window.matchMedia('(max-width: 990px)');
      this.onMediaChangeHandler = this.setHeaderHeight.bind(this);

      if (this.mediaQuery.addEventListener) {
        this.mediaQuery.addEventListener('change', this.onMediaChangeHandler);
      } else if (this.mediaQuery.addListener) {
        this.mediaQuery.addListener(this.onMediaChangeHandler);
      }

      if (this.headerIsAlwaysSticky) {
        this.forceSticky();
      }

      this.onScrollHandler = this.onScroll.bind(this);
      this.onResizeHandler = this.setHeaderHeight.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('resize', this.onResizeHandler, { passive: true });

      this.createObserver();
      this.onScroll();
    }

    setHeaderHeight() {
      if (!this.header) return;

      const headerHeight = this.header.offsetHeight;
      const headerTop = this.header.offsetTop || 0;

      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);

      this.headerBounds = {
        top: headerTop,
        bottom: headerTop + headerHeight,
      };
    }

    enableFixedFallback() {
      if (!this.header) return;

      this.header.classList.add('te-fixed-header');
      this.header.style.position = 'fixed';
      this.header.style.top = '0';
      this.header.style.left = '0';
      this.header.style.right = '0';
      this.header.style.width = '100%';
      this.header.style.zIndex = '200';

      const headerWrapper = this.querySelector('.header-wrapper') || this;
      const isTransparent = headerWrapper.classList.contains('header-wrapper--transparent');

      if (!isTransparent && document.getElementById('MainContent')) {
        document.getElementById('MainContent').style.paddingTop = `${this.header.offsetHeight}px`;
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);

      if (this.mediaQuery && this.onMediaChangeHandler) {
        if (this.mediaQuery.removeEventListener) {
          this.mediaQuery.removeEventListener('change', this.onMediaChangeHandler);
        } else if (this.mediaQuery.removeListener) {
          this.mediaQuery.removeListener(this.onMediaChangeHandler);
        }
      }
    }

    createObserver() {
      if (!this.header || typeof IntersectionObserver === 'undefined') return;

      const observer = new IntersectionObserver((entries, observerInstance) => {
        const entry = entries[0];
        const pageTop = window.pageYOffset || document.documentElement.scrollTop || 0;
        const headerHeight = this.header.offsetHeight;

        this.headerBounds = {
          top: entry.boundingClientRect.top + pageTop,
          bottom: entry.boundingClientRect.top + pageTop + headerHeight,
        };

        observerInstance.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (!this.header) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.headerIsAlwaysSticky) {
        this.forceSticky();

        if (scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
        } else {
          this.header.classList.remove('scrolled-past-header');
        }

        this.currentScrollTop = scrollTop;
        return;
      }

      if (!this.headerIsOnScrollUp) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    forceSticky() {
      this.header.classList.add('shopify-section-header-sticky', 'te-header-sticky-active');
      this.header.classList.remove('shopify-section-header-hidden', 'te-header-hidden');
    }

    hide() {
      if (!this.headerIsOnScrollUp) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky', 'te-header-hidden', 'te-header-sticky-active');
      this.header.classList.remove('animate');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (!this.headerIsOnScrollUp) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate', 'te-header-sticky-active');
      this.header.classList.remove('shopify-section-header-hidden', 'te-header-hidden');
    }

    reset() {
      if (!this.headerIsOnScrollUp) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate', 'te-header-hidden', 'te-header-sticky-active');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => {
        if (typeof disclosure.close === 'function') disclosure.close();
      });
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && typeof this.searchModal.close === 'function') this.searchModal.close(false);
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
